<template>
	<!-- 面包屑导航横向 -->
  <div class="breadcrumb app-region">
    <a-page-header :class="{back: !$route.meta.noBack}" :title="$route.meta.title" :sub-title="$route.name" @back="() => $router.go(-1)">
      <template slot="extra">
        <a-breadcrumb>
          <a-breadcrumb-item v-for="(value, index) in $route.meta.path.filter(val => !val.type || val.type > -1).reverse()" :key="index">{{value.title}}</a-breadcrumb-item>
          <a-breadcrumb-item>{{$route.meta.title}}</a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
  </div>
</template>

<script>
  export default {
    name: 'Breadcrumb'
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .breadcrumb {
    
  }
</style>